import lazyLoad from '@loadable/component';
export default lazyLoad;
//# sourceMappingURL=index.js.map